/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSuggestRosreestrDataModel,
  ISuggestRosreestrDataRequest,
  IMappers,
  ISuggestRosreestrDataResponse,
  ISuggestRosreestrDataResponseError,
  TSuggestRosreestrDataResponse,
} from './types';

const defaultConfig: TSuggestRosreestrDataModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'countryside-rosreestr',
  pathApi: '/v1/suggest-rosreestr-data/',
  hostType: 'api',
} as TSuggestRosreestrDataModel;

function createSuggestRosreestrDataModel(parameters: ISuggestRosreestrDataRequest): TSuggestRosreestrDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISuggestRosreestrDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISuggestRosreestrDataRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSuggestRosreestrData<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISuggestRosreestrDataOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSuggestRosreestrDataResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSuggestRosreestrDataModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISuggestRosreestrDataResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISuggestRosreestrDataResponseError);
    }
  }

  return { response, statusCode } as TSuggestRosreestrDataResponse;
}

export { defaultConfig, createSuggestRosreestrDataModel, fetchSuggestRosreestrData };
